import { getTemple } from "../../js/storage";
import { downLoadBlobFile, getKeyTitle, isEmpty } from "../../js/tool";

export const flagOptions = [
  { key: 1, title: "是" },
  { key: 2, title: "否" },
];

export const getFlagText = function (value) {
  return getKeyTitle(flagOptions, value);
};

export default {
  name: "突发事件",
  url: "/admin/record-burst-handle", // rest接口表名
  query: "&sort=-id", // rest接口query参数
  searchKeyType: {
    date: function (form, key) {
      let value = form[key];
      let res = "";
      if (value?.length > 0) {
        res = `&filter[create_time][gte]=${value[0]} 00:00:00&filter[create_time][lte]=${value[1]} 23:59:59`;
      }
      return res;
    },
    event: 1,
  },
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      {
        title: "提交时间",
        dataIndex: "create_time",
        customRender: (text) => text?.slice(0, -3),
      },
      {
        title: "提交人",
        dataIndex: "wx_user_id",
        customRender: (text) => <open-data type="userName" openid={text} />,
      },
      { title: "事件", dataIndex: "event" },
    ];
  },
  // 列表查询表单
  queryForm: [
    {
      key: "wx_user_id",
      label: "提交人",
      component: "select-book",
      props: {
        type: "user",
      },
    },
    {
      key: "date",
      label: "提交日期",
      component: "a-range-picker",
      props: {
        placeholder: ["开始日期", "结束日期"],
        format: "YYYY-MM-DD",
        valueFormat: "YYYY-MM-DD",
        allowClear: true,
        class: "range-picker",
      },
      style: {
        width: "240px",
      },
    },
    {
      key: "event",
      label: "事件",
      component: "a-input",
      props: {
        placeholder: "输入事件查询",
        allowClear: true,
      },
      style: {
        width: "200px",
      },
    },
  ],
  buttons: [
    {
      name: "数据导出",
      component: "a-button",
      type: "primary",
      props: {
        type: "primary",
      },
      style: {
        "margin-left": "8px",
      },
      value: null,
      listeners: {
        click() {
          if (this.exporting) return;
          this.$set(this, "exporting", false);
          const temple = getTemple();
          let url = `/admin/record-burst-handle/export?temple_id=${temple}`;
          const form = this.$refs.dataList.form;
          if (form.wx_user_id) {
            url += `&wx_user_id=${form.wx_user_id}`;
          }
          if (form.date?.length === 2) {
            url += `&start_time=${form.date[0]}&end_time=${form.date[1]}`;
          }
          if (!isEmpty(form.event)) {
            url += `&event=${form.event}`;
          }
          this.$axios(url, { noTempleFilter: true, responseType: "blob" })
            .then((res) => {
              downLoadBlobFile(res, "突发事件数据");
            })
            .finally(() => {
              this.exporting = false;
            });
        },
      },
    },
  ],
  // 新增/编辑查询表单
  items: [],
  // 详情接口expand字段
  expand: "",
  init: {}, // 新增实体初始化字段
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "提交时间", key: "create_time", slot: (entity) => <span>{entity.create_time?.slice(0, -3)}</span> },
      {
        label: "提交人",
        key: "wx_user_id",
        slot: (entity) => <open-data type="userName" openid={entity.wx_user_id} />,
      },
      { label: "事件", key: "event" },
      { label: "事件性质", key: "event_property" },
      { label: "日期", key: "date" },
      { label: "发生地点", key: "location" },
      { label: "姓名", key: "name" },
      { label: "联系方式", key: "mobile" },
      { label: "地址", key: "address" },
      { label: "事件描述", key: "describe" },
      { label: "处理结果", key: "result" },
      { label: "处理事项与回访", key: "attention" },
      {
        label: "处理人",
        key: "handle_wx_user_id",
        slot: (entity) => <open-data type="userName" openid={entity.handle_wx_user_id} />,
      },
    ];
  },
};
